import { render, staticRenderFns } from "./Returndetails.vue?vue&type=template&id=090ba3bc&scoped=true"
import script from "./Returndetails.vue?vue&type=script&lang=js"
export * from "./Returndetails.vue?vue&type=script&lang=js"
import style0 from "./Returndetails.vue?vue&type=style&index=0&id=090ba3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ba3bc",
  null
  
)

export default component.exports